import {Base} from './base'
import Auth from './auth'
import Admin from './admin'
import User from './user'
import Event from './event'
export {Post} from './wp'

class Api
{
	// Vuex store instance
	store = null

	// Utils
	util = {}

	/**
	 * Default constructor
	 */
	constructor(store = null)
	{
		this.store = store
	}

	/**
	 * Set store used for authentication
	 */
	setStore(store)
	{
		this.store = store
	}

	/**
	 * Create a new adventure prototype
	 * 
	 * @param {Number} id adventure id
	 * @param {VuexStore} store override default instance
	 * @returns {Adventure}
	 */
	adventure(id, store = null)
	{
		return new Adventure(id, store || this.store)
	}

	/**
	 * Create a new auth prototype
	 * 
	 * @param {VuexStore} store override default instance
	 * @returns {Auth}
	 */
	auth(store = null)
	{
		return new Auth(store || this.store)
	}

	/**
	 * Create a new admin prototype
	 * 
	 * @param {VuexStore} store override default instance
	 * @returns {Admin}
	 */
	admin(store = null)
	{
		return new Admin(store || this.store)
	}

	/**
	 * Create a new user prototype
	 * 
	 * @param {Number} id user id or null
	 * @param {VuexStore} store override default instance
	 * @returns {User}
	 */
	user(id = null, store = null)
	{
		return new User(id, store || this.store)
	}

	/**
	 * 
	 */
	event(id = null, store = null)
	{
		return new Event(id, store || this.store)
	}

	/**
	 * Make request
	 */
	async make(method, ...args)
	{
		let base = new Base(this.store)
		switch (method) {
			case 'GET': return base._get(...args)
			case 'POST': return base._post(...args)
			case 'PUT': return base._put(...args)
			case 'DELETE': return base._delete(...args)
			default: throw Error('Unknown method ' + method)
		}
	}

	/**
	 * Vue plugin install script
	 */
	static install(Vue, options)
	{
		if (this.bInstalled)
			// Don't install twice
			return
		
		this.bInstalled = true;
		
		/**
		 * I kinda looked up this technique
		 * from vue router
		 */
		Vue.mixin({
			/**
			 * Called before component creation
			 */
			beforeCreate() {

				if (this.$options.api !== undefined)
				{
					this._apiRoot = this
					this._api = this.$options.api
				}
				else
					this._apiRoot = (this.$parent && this.$parent._apiRoot) || this
			}
		})

		Object.defineProperty(Vue.prototype, '$api', {
			get() {

				return this._apiRoot._api
			}
		})
	}
}

export default Api